module.exports = new __parcel__URL__("people-and-tasks.dedc2456.svg").toString();